import styled from 'styled-components';
import { MessageMedium } from 'constants/messageMediums';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { EmptyState } from 'ui/emptyState';
import { ListEmptyTableState } from 'ui/illustrations';
import { Link } from 'ui/links';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Body1Light } from '../Content.styles';

const Wrapper = styled.div`
  padding: ${spacing.x6} 0;
`;

const DescriptionWrapper = styled.div`
  max-width: ${pxToRem(460)};
`;

const getSupportLink = (messageMedium: SupportedMediums) => {
  switch (messageMedium) {
    case MessageMedium.Email:
      return 'https://support.iterable.com/hc/en-us/articles/7130133854612-Email-Setup';
    case MessageMedium.Push:
      return 'https://support.iterable.com/hc/en-us/articles/360035079872-Push-Notification-Overview';
    case MessageMedium.SMS:
      return 'https://support.iterable.com/hc/en-us/articles/211970843-SMS-Overview';
    default:
      return 'https://support.iterable.com';
  }
};

export const NotConfigured = ({ messageMedium }: { messageMedium: SupportedMediums }) => (
  <Wrapper>
    <EmptyState
      Illustration={ListEmptyTableState}
      title={`${messageMedium} has not been configured yet`}
      subtitle={
        <DescriptionWrapper>
          <Body1Light>
            There are no {messageMedium} subscription channels or message types.
          </Body1Light>
          <Body1Light>
            <Link href={`/settings/channels/${messageMedium}`} size="body1">
              Go to {messageMedium} Message Channels and Types
            </Link>{' '}
            or learn more by visiting our{' '}
            <Link href={getSupportLink(messageMedium)} size="body1">
              Knowledge Center
            </Link>
            .
          </Body1Light>
        </DescriptionWrapper>
      }
    />
  </Wrapper>
);
